import mobileTpl from './templates/mobile.pug';
import desktopTpl from './templates/desktop.pug';

export default class Component {
  render() {
    const div = document.createElement('div');

    if (window.device === 'mobile') {
      div.innerHTML = mobileTpl();
    } else {
      div.innerHTML = desktopTpl();
    }
    document.body.appendChild(div.firstChild);
    require('./legacy-code/paywall');
  }
}
